import { FilterObject } from '../models/filter/filter.object';

export class FilterObjectWrapper {
    public filterObject: FilterObject;
    public filterObjectCopy: FilterObject;

    constructor(filterObjectTmp: FilterObject = null) {
        if(!filterObjectTmp) {
            this.filterObject = new FilterObject();
            return;
        }

        this.filterObject = filterObjectTmp;
        this.filterObjectCopy = FilterObject.parse(filterObjectTmp);
    }
    
    setFilterObject( filterObject: FilterObject ): void {
        
    };
    
    updateFilterObject(filterObjectTmp: FilterObject): void{
        this.filterObject.copyFrom(filterObjectTmp);
        this.filterObjectCopy = FilterObject.parse(filterObjectTmp)
    }
}